// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"472":"d7f819b9","572":"552aa80b","591":"a757b656","864":"552aa80b"}[chunkId] + ".chunk.css";
};